<template>
  <div
    ref="rootEl"
    role="button"
    :tabindex="isDisabled ? -1 : 0"
    :aria-disabled="isDisabled || undefined"
    class="cursor-pointer"
    @click="onClick"
    @keydown="onKeydown"
  >
    <IonSpinner v-if="isLoading" name="dots" class="custom-ion-button-spinner" />
    <slot v-else />
  </div>
</template>

<script lang="ts">
import { IonSpinner } from "@ionic/vue";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "CustomSimpleButton",
  components: { IonSpinner },
  props: {
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
  },
  emits: ["onClick"],
  setup(props, { emit }) {
    const rootEl = ref<HTMLElement | null>(null);

    function onKeydown(event: KeyboardEvent): void {
      if (props.isDisabled || (event.key !== "Enter" && event.key !== " ") || props.isLoading) {
        return;
      }
      event.preventDefault();
      rootEl.value?.click();
    }

    function onClick(event: MouseEvent): void {
      if (props.isDisabled) {
        return;
      }
      emit("onClick", event);
    }

    return { rootEl, onClick, onKeydown };
  },
});
</script>
